<template>
    <li>
        <div class="title"><span>ターゲット</span></div>
        <div class="detail _range">

            <div class="edit-select">
                <select name="" id="edit-target-lower-limit" v-model="target_min" v-on:change="selectTargetMin" v-bind:class="{ '_error _required':  $store.state.register.errors.target_min }">
                    <option v-for="target_min in target_mins" 
                        v-bind:value="target_min.value" 
                        v-bind:key="target_min.id">
                        {{ target_min.value }}代
                    </option>
                </select>
            </div>

            <div class="edit-select">
                <select name="" id="edit-target-upper-limit" v-model="target_max" v-on:change="selectTargetMax" v-bind:class="{ '_error _required':  $store.state.register.errors.target_max }">
                    <option v-for="target_max in target_maxs" 
                        v-bind:value="target_max.value" 
                        v-bind:key="target_max.id">
                        {{ target_max.value }}代
                    </option>
                </select>
            </div>
            <span style="color: red" v-if="$store.state.register.errors.target_min || $store.state.register.errors.target_max">必須項目を入力してください</span>
        </div>
    </li>
</template>

<script>
    export default {
        data() {
            return {
                target_min: '',
                target_max: '',
                targets: [
                    { value: 0 },
                    { value: 10 },
                    { value: 20 },
                    { value: 30 },
                    { value: 40 },
                    { value: 50 },
                    { value: 60 },
                    { value: 70 },
                    { value: 80 },
                ],
                target_mins: [],
                target_maxs: [],
            }
        },
        created() {
            this.target_maxs = this.targets;
            this.target_mins = this.targets;

            // 編集の場合
            if (this.$store.state.detail.set.brand.target_min) {
                this.target_min = this.$store.state.detail.set.brand.target_min;
                this.$store.state.register.form.target_min = this.$store.state.detail.set.brand.target_min;
            }
            if (this.$store.state.detail.set.brand.target_max) {
                this.target_max = this.$store.state.detail.set.brand.target_max;
                this.$store.state.register.form.target_max = this.$store.state.detail.set.brand.target_max;
            }
        },
        methods: {
            selectTargetMin() {
                var items = [];
                var target_min = this.target_min;
                this.target_maxs = this.targets;

                this.target_maxs.forEach(function(item, index){
                    if (item.value > target_min) {
                        items.push(item)
                    }
                });

                this.target_maxs = items;
                this.$store.state.register.form.target_min = this.target_min;

            },
            selectTargetMax() {
                var items = [];
                var target_max = this.target_max;
                this.target_mins = this.targets;

                this.target_mins.forEach(function(item, index){
                    if (item.value < target_max) {
                        items.push(item)
                    }
                });

                this.target_mins = items;
                this.$store.state.register.form.target_max = this.target_max;
            }
        }
    }
</script>
